import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import FactorsImpactingPrice from 'offer/components/sidebar/components/factors-impacting-price';
import checklistIcon from 'core/assets/svg/check-list.svg';
import useStyles from './impact-factors.styles';

const ImpactFactors = ({ factors }) => {
  const classes = useStyles();
  const [showFactorsImpactingPriceModal, setShowFactorsImpactingPriceModal] = useState(false);
  const toggleModal = useCallback(
    () => setShowFactorsImpactingPriceModal(!showFactorsImpactingPriceModal),
    [setShowFactorsImpactingPriceModal, showFactorsImpactingPriceModal]
  );

  return (
    <>
      {factors && (
        <div className={classes.container}>
          <Button
            variant="contained"
            color="primary"
            disabled={!factors}
            onClick={toggleModal}
            className={classes.button}
          >
            <Label className={classes.buttonLabel}>
              <img src={checklistIcon} alt="checklist" />
              See price & eligibility factors
            </Label>
          </Button>
        </div>
      )}
      {showFactorsImpactingPriceModal && (
        <FactorsImpactingPrice open={showFactorsImpactingPriceModal} onClose={toggleModal} factors={factors} />
      )}
    </>
  );
};

ImpactFactors.propTypes = {
  factors: PropTypes.object.isRequired
};

export default ImpactFactors;
